<template>
<div>
    <kt-col xs="12" class="mb-5">
        <span v-if="form_data.logo == null">
            <img src="/assets/media/image-not-found.png" style="max-width:300px" class="d-block m-auto" :title="$t('label.image_not_found')"/>
        </span>
        <span v-else>
            <img :src="form_data.logo" style="max-width:300px" class="d-block m-auto">
        </span>
    </kt-col>


    <form @submit.prevent="submit" id="gateway_form">
        <kt-form-section is_first>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="user_full_name">
                            {{ $t('label.User_full_name') }} {{' :'}}
                        </kt-form-label>
                        <router-link :to="'/users/'+ form_data.user.user_id +'/details'">
                            {{form_data.user.full_name}}
                        </router-link>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="12" md="12" xs="12">
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="merchant_type">
                                    {{ $t('label.merchant_type') }}
                                </kt-form-label>
                                <select
                                        id="merchant_type"
                                        name="merchant_type"
                                        v-model="form_data.merchant_type"
                                        class="form-control kt-selectpicker"
                                        :disabled="form_data.user.user_type == user_types.LEGAL"
                                >
                                    <option value=0>
                                        {{ $t('label.real') }}
                                    </option>
                                    <option value=1>
                                        {{ $t('label.legal') }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="merchant_type">
                                    {{ $t('label.gateway_type') }}
                                </kt-form-label>
                                <select
                                        id="shop_type"
                                        name="shop_type"
                                        v-model="form_data.shop_type"
                                        class="form-control kt-selectpicker"
                                >
<!--                                    <option value="1" :selected="form_data.shop_type == 1">-->
<!--                                        {{ $t('gateway.gateway_types.pardakht_shakhsi') }}-->
<!--                                    </option>-->
                                    <option value="2" :selected="form_data.shop_type == 2">
                                        {{ $t('gateway.gateway_types.business') }}
                                    </option>
<!--                                    <option value="3" :selected="form_data.shop_type == 3">-->
<!--                                        {{ $t('gateway.gateway_types.collective') }}-->
<!--                                    </option>-->
                                    <option value="4" :selected="form_data.shop_type == 4">
                                      {{ $t('gateway.gateway_types.business_psp_settlement') }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="12" md="12" xs="12" v-if="form_data.merchant_type == 1">
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="com_name_fa">
                                    {{ $t('label.com_name_fa') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="com_name_fa"
                                        name="com_name_fa"
                                        v-model="form_data.com_name_fa"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="com_name_en">
                                    {{ $t('label.com_name_en') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="com_name_en"
                                        name="com_name_en"
                                        dir="ltr"
                                        v-model="form_data.com_name_en"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="national_legal_code">
                                    {{ $t('label.national_legal_code') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="national_legal_code"
                                        name="national_legal_code"
                                        v-model="form_data.national_legal_code"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="12" xs="6">
                            <kt-form-group>
                                <kt-form-label for="register_number">
                                    {{ $t('label.register_number') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="register_number"
                                        name="register_number"
                                        v-model="form_data.register_number"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="register_date">
                                    {{ $t('label.com_register_date') }}
                                </kt-form-label>
                                <datePicker
                                        format="YYYY-MM-DD HH:mm:ss"
                                        display-format="jDD jMMMM jYYYY"
                                        input-class="form-control"
                                        id="register_date"
                                        name="register_date"
                                        v-model="form_data.register_date" type="date" />
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>

                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="farsi_name">
                            {{ $t('label.farsi_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="farsi_name"
                                name="farsi_name"
                                v-model="form_data.farsi_name"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="english_name">
                            {{ $t('label.english_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="english_name"
                                name="english_name"
                                v-model="form_data.english_name"
                                dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="gateway_id">
                            {{ $t('label.gateway_id') }}
                        </kt-form-label>
                        <kt-form-control
                                id="gateway_id"
                                name="gateway_id"
                                v-model="form_data.gateway_id"
                                disabled
                                dir="rtl"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="business_certificate_number">
                            {{ $t('label.business_certificate_number') }}
                        </kt-form-label>
                        <kt-form-control
                            id="business_certificate_number"
                            name="business_certificate_number"
                            v-model="form_data.business_certificate_number"
                            dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="sign_key">
                            {{ $t('label.sign_key') }}
                        </kt-form-label>
                        <textarea
                            name="sign_key"
                            id="sign_key"
                            class="form-control"
                            rows="5"
                            style="resize: none;"
                            disabled
                            :value="form_data.sign_key"
                        >
                        </textarea>
                    </kt-form-group>
                </kt-col>
                
            </kt-row>
            <kt-row>
                <div class="col-12">
                    <kt-form-group>
                        <kt-form-label for="subcategory_code">
                            {{ $t('label.subcategory_code') }}
                        </kt-form-label>
                        <select
                                id="subcategory_code"
                                name="subcategory_code"
                                v-model="form_data.subcategory_code"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="subcategory.key"
                                    v-for="subcategory in subcategories"
                                    :selected="form_data.subcategory_code == subcategory.key"
                                    :value="subcategory.key"
                            >
                                {{ subcategory.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </div>
            </kt-row>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="provinces">
                                    {{ $t('label.province') }}
                                </kt-form-label>
                                <select
                                    id="provinces"
                                    name="provinces"
                                    v-model="form_data.province_code"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        v-bind:key="province.id"
                                        v-for="province in provinceCodes"
                                        :selected="form_data.province_code == province.province_code"
                                        :value="province.province_code"
                                    >
                                        <span>{{ province.name }}</span>
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="cities">
                                    {{ $t('label.city') }}
                                </kt-form-label>
                                <select
                                    id="cities"
                                    name="cities"
                                    v-model="form_data.city_code"
                                    class="form-control"
                                >
                                    <option
                                        v-bind:key="city.city_code"
                                        v-for="city in getProvinceCities"
                                        :selected="form_data.city_code == city.city_code"
                                        :value="city.city_code"
                                    >
                                        <span>{{ city.name }}</span>
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="address">
                            {{ $t('label.address') }}
                        </kt-form-label>
                        <select
                                v-if="addresses"
                                id="address"
                                name="address"
                                v-model="form_data.address"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="address.id"
                                    v-for="address in addresses"
                                    :selected="form_data.address == address.id"
                                    :value="address.id"
                            >
                            <span>{{ address.address + ' / ' + $t('label.postal_code') + ': ' }}</span>
                            <span v-text="correctDirectionPostalCode(address.postal_code)"></span>
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="telephone">
                            {{ $t('label.telephone') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="telephone"
                                name="telephone"
                                v-model="form_data.telephone"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="tax_payer_code">
                            {{ $t('label.tax_payer_code') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="tax_payer_code"
                                name="tax_payer_code"
                                v-model="form_data.tax_payer_code"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>

        <kt-form-section>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="site_address">
                            {{ $t('label.site_address') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="site_address"
                                name="site_address"
                                placeholder="https://mysite.ir/"
                                v-model="form_data.site_address"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="email_address">
                            {{ $t('label.email') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="email_address"
                                name="email_address"
                                v-model="form_data.email_address"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
<!--                <kt-col lg="12" md="12" xs="12">-->
<!--                    <kt-form-group>-->
<!--                        <kt-form-label for="server_ip">-->
<!--                            {{ $t('label.server_ip') }}-->
<!--                        </kt-form-label>-->
<!--                        <kt-input-group class="">-->
<!--                            <kt-form-control dir="ltr" name="server_ip" id="server_ip" v-model="form_data.server_ip"></kt-form-control>-->
<!--                            <kt-input-group-append>-->
<!--                                <kt-input-group-text style="padding: 0">-->
<!--                                    <country-flag v-if="form_data.server_ip_country_code"-->
<!--                                                  :country="form_data.server_ip_country_code"-->
<!--                                                  style="height: calc(1.5em + 1.3rem );"-->
<!--                                    />-->
<!--                                    <span v-else style="height: calc(1.5em + 1.3rem );padding: 10px" >-</span>-->
<!--                                </kt-input-group-text>-->
<!--                            </kt-input-group-append>-->
<!--                        </kt-input-group>-->
<!--                    </kt-form-group>-->
<!--                </kt-col>-->
                <kt-col lg="12" md="12" xs="12">
                  <kt-form-label>
                    {{ $t('label.allowed_ips') }}
                  </kt-form-label>
                </kt-col>
                <kt-col lg="12" md="12" xs="12" v-for="(ip, index) in form_data.allowed_ips">
                    <kt-form-group>
                        <div>
                            <textarea dir="ltr"
                                      style="resize: none;"
                                      :value="ip"
                                      disabled
                            >
                            </textarea>
                        </div>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <div class="custom-control custom-switch">
                            <input
                                disabled
                                type="checkbox"
                                class="custom-control-input"
                                id="use_push_transaction"
                                name="use_push_transaction"
                                v-model="form_data.use_push_transaction"
                            >
                            <label class="custom-control-label" for="use_push_transaction">{{
                                    $t('label.use_push_transaction') }}</label>
                        </div>
                    </kt-form-group>
                </kt-col>

                <!-- <kt-col lg="12" md="12" xs="12">
                  <kt-form-group>
                    <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="dont_check_for_inactiveness"
                      name="dont_check_for_inactiveness"
                      v-model="form_data.dont_check_for_inactiveness"
                    />
                      <label class="custom-control-label" for="dont_check_for_inactiveness">
                        {{ $t('label.dont_check_for_inactiveness') }}
                      </label>
                    </div>
                  </kt-form-group>
                </kt-col> -->

                <!-- <kt-col lg="12" md="12" xs="12">
                  <kt-form-group>
                    <kt-form-label for="wage">
                      {{ $t('label.wage') }}
                    </kt-form-label>
                    <select
                        id="wage"
                        name="wage"
                        v-model="form_data.merchant_share_percent"
                        @change="selectChange($event)"
                        class="form-control kt-selectpicker"
                    >
                      <option
                          v-for="wage in wages"
                          v-bind:key="wage.id"
                          :value="wage.id"
                      >
                        {{ wage.value }}
                      </option>
                    </select>
                  </kt-form-group>
                </kt-col>
                <kt-col v-if="(
                      form_data.merchant_share_percent != 0 &&
                      form_data.merchant_share_percent != 100
                      )" lg="6" md="6" xs="12">
                  <kt-form-group>
                    <kt-form-label for="merchant_wage_share">
                      {{ $t('label.merchant_wage_share') }}
                    </kt-form-label>
                    <input
                        type="number"
                        max="99"
                        min="1"
                        id="merchant_share_percent"
                        name="merchant_share_percent"
                        v-model="form_data.merchant_share_percent"
                        class="form-control kt-selectpicker"
                    >
                  </kt-form-group>
                </kt-col>
                <kt-col v-if="(
                      form_data.merchant_share_percent != 0 &&
                      form_data.merchant_share_percent != 100
                      )" lg="6" md="6" xs="12">
                  <kt-form-group>
                    <kt-form-label for="client_wage_share">
                      {{ $t('label.client_wage_share') }}
                    </kt-form-label>

                    <p
                        class="form-control disabled"
                        id="client_wage_share"
                        name="client_wage_share"
                    >
                      {{ !form_data.merchant_share_percent ? "" : 100 - form_data.merchant_share_percent }}
                    </p>
                  </kt-form-group>
                </kt-col> -->
            </kt-row>
        </kt-form-section>

        <kt-form-action class="mt-4">
            <kt-button
                    class="m-2"
                    size="md"
                    variant="success"
                    type="submit"
                    v-bind:wide="true"
                    id="submit_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>
    </form>
</div>
</template>

<script>
import {subcategories} from '@/constants/subcategories'
import {province_codes, provinceCities} from '@/constants/cityAndProvinceCodes'
import $ from 'jquery'
import Inputmask from 'inputmask'
import {mapGetters} from 'vuex'
import {i18n} from '@/plugins/i18n'
import {userTypes} from '@/constants/userTypes';
import CountryFlag from 'vue-country-flag'
import {shebaNumberShaparakStatusStr} from "@/constants/shebaNumberShaparaktatus";

export default {
    components: {
        CountryFlag
    },
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            user_types: userTypes,
            subcategories: subcategories,
            provinceCodes: province_codes,
            'hashid': this.$route.params.hashid,
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 100,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: (this.form_data.merchant_share_percent !== 100 && this.form_data.merchant_share_percent !== 0)
                        ? this.form_data.merchant_share_percent : 50,
                    value: this.$t('gateway.wages.half')
                }
            ]
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        correctDirectionPostalCode(code) {
            code = String(code);
            let index = code.indexOf('-');

            if (index == -1) {
                return code;
            }

            let part1 = code.substring(0, index);
            let part2 = code.substring(index + 1);
            code = part2 + '-' + part1;
            
            return code;
        },
        selectChange(event){
            this.form_data.merchant_share_percent = event.target.value
        },
        afterDispatch() {
            setTimeout(function(){
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 1000);

            document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'))
        },
    },
    computed: {
        shebaNumberShaparakStatusStr() {
            return shebaNumberShaparakStatusStr
        },
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'iban_list'
        ]),
        getProvinceCities() {
            return provinceCities(this.form_data.province_code);
        },
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>